import { Injectable } from '@angular/core';
import { createWarning } from '@core/helpers/create-validator.helper';
import { Store } from '@ngrx/store';
import { Revisione53State } from 'app/features/revisione53/core/store/revisione53.reducers';
import { isBefore } from 'date-fns';

@Injectable()
export class NormeSpaDualisticoWarningsService {
    constructor(private store: Store<Revisione53State>) {}

    my_DataRevisioneDal = createWarning(this.store, (myVerbale) => {
        const my_DataRevisioneDal = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_DataRevisioneDal;
        const my_SpdElemConsiglioGestione =
            myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSpaDualistico.my_SpdConsiglioGestione.my_SpdElemConsiglioGestione;

        const date = new Date(my_DataRevisioneDal);
        const dateBefore = isBefore(date, new Date('01-01-2018'));

        if (!(dateBefore || my_SpdElemConsiglioGestione.length <= 0 || my_SpdElemConsiglioGestione.length >= 3)) {
            return "Attenzione: per le modifiche introdotte dalla legge di bilancio 2018, l'amministrazione della cooperativa non può essere affidata ad un Consiglio di Gestione con meno di tre componenti";
        } else {
            return null;
        }
    });
}
